import { render } from "./ProjectForeignEstablishment.vue?vue&type=template&id=65dce613"
import script from "./ProjectForeignEstablishment.vue?vue&type=script&lang=js"
export * from "./ProjectForeignEstablishment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__